import * as React from 'react';
import Box from '@mui/material/Box';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { ICustomerImage } from '../queries/CustomerDigitalStylingApi';
import { CustomerImages } from './CustomerImages';

export type DigitalStylingOrderViewLabels = {
    downloadNormalResolutionButton: string;
    downloadHighResolutionButton: string;
};

type DigitalStylingOrderViewProps = {
    images: ICustomerImage[];
    labels: DigitalStylingOrderViewLabels;
    hasNormalResolutionImagesAvailable: boolean;
    onDownloadHighResolutionImages: () => void;
    onDownloadNormalResolutionImages: () => void;
};

export function DigitalStylingOrderView({
    images,
    labels,
    hasNormalResolutionImagesAvailable,
    onDownloadNormalResolutionImages,
    onDownloadHighResolutionImages
}: DigitalStylingOrderViewProps) {
    return (
        <fieldset>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Stack
                    sx={{ justifyContent: 'flex-end', padding: '20px 0' }}
                    direction="row"
                    spacing={2}
                >
                    {hasNormalResolutionImagesAvailable ? (
                        <Button
                            variant="contained"
                            startIcon={<CloudDownloadIcon />}
                            onClick={onDownloadNormalResolutionImages}
                        >
                            {labels.downloadNormalResolutionButton}
                        </Button>
                    ) : null}
                    <Button
                        variant="contained"
                        startIcon={<CloudDownloadIcon />}
                        onClick={onDownloadHighResolutionImages}
                    >
                        {labels.downloadHighResolutionButton}
                    </Button>
                </Stack>
                <Box sx={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
                    <CustomerImages images={images} />
                </Box>
            </Box>
        </fieldset>
    );
}
